import {Component, Input, OnInit} from '@angular/core';
import {OrderService} from "../../services/OrderService";
import {MenuController, ModalController, NavController} from "@ionic/angular";
import {ModelAddPage} from "../../../framework/pages/model-add/model-add.page";
import {Section} from "../../../framework/model/core/sections/section";
import {SearchPage} from "../../pages/search/search.page";
import {BusinessService} from "../../services/BusinessService";
import {BusinessImages} from "../../../framework/model/core/business/businessImages";
import {AppSettings} from "../../conf/appSettings";
import {Events} from "../../../framework/providers/events";
import {ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router} from "@angular/router";
import {AppConfig} from "../../../core/conf/main";
import {ModelToolsProvider} from "../../../framework/providers/model-tools/model-tools";

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
})
export class AppHeaderComponent implements OnInit {

    @Input()
    public title;

    public pageName: string = '';

    // @Input()
    public menu: boolean = true;
    public backButton: boolean = true;

    @Input()
    public modal: boolean = false; // ?

    @Input()
    public ismodal: boolean = false; // ?

    @Input()
    public showLogo: boolean = false;

    @Input()
    public closeButton: boolean = true;

    public cartData: object;

    public catalog: boolean = this.businessService.isCatalog();

    public businessImages: BusinessImages;

    public settings;
    public AppConfig = AppConfig;

    appuser;
    buttons;


    constructor(public orderService: OrderService, public navCtrl: NavController, public events: Events, public modalController: ModalController, public tools:ModelToolsProvider,
                public businessService: BusinessService, public appSettings: AppSettings, private route: ActivatedRoute, private router: Router) {
        this.cartData = orderService.getCartData();
        this.settings = appSettings.getSettings('app');
        this.appuser = this.orderService.getAppUser();

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                //do something on start activity
            }

            if (event instanceof NavigationError) {
                // Handle error
                console.error(event.error);
            }

            if (event instanceof NavigationEnd) {
                this.setTitle();
            }
        });

        this.events.subscribe('catalogChanged', (params) => {
            this.catalog = params['catalog'];
        });

        this.events.subscribe('cartUpdated', (params) => {
            // this.cartData = orderService.getCartData();
            // //console.log'$$$', this.cartData);

        });

        this.businessImages = this.businessService.getImages();
        this.events.subscribe('businessImagesSets', (params) => {
            this.businessImages = this.businessService.getImages();
            ////console.log'businessImages', this.businessImages)
            this.showLogo = this.businessImages.data['logo2'] != null;
        });

        this.events.subscribe('appuserChanged', (params) => {
            this.appuser = this.orderService.getAppUser();
            this.setNav();
        });

        this.events.subscribe('agentCompanyChanged', (params) => {
            this.appuser = this.orderService.getAppUser();
            this.setNav();
        });
    }


    ngOnInit() {
        this.setTitle();
        this.setNav();
        this.appuser = this.orderService.getAppUser();
    }

    setNav() {
        this.buttons = [
            {
                'title': 'mainPage',
                'icon': 'home',
                'url': 'main'
            },
            {
                'title': this.businessService.getBusiness().data.GlobalSettingsData.menuText ? this.businessService.getBusiness().data.GlobalSettingsData.menuText : 'store',
                'icon': 'basket',
                'url': 'store'
            },
        ]

        let profile_btn = {
            // 'color': 'warning',
            'title': 'myProfile',
            'icon': 'person',
            'secIcon': 'briefcase',
            'url': 'profile'
        };

        this.buttons.push(profile_btn)
        if (this.appuser) {
            profile_btn['title'] = this.appuser.data.name;
            if (this.orderService.isAgent()) {
                let url = this.appuser.data.companyOurId != '-1' ? 'client-page/' + this.appuser.data.companyId + '/1' : 'agent-clients';
                this.buttons.push({
                    'color': 'warning',
                    'title': this.appuser.data.companyName,
                    'icon': 'briefcase',
                    'fill': 'solid',
                    'url': url
                })
            }
        }

    }

    setTitle() {
        if (this.ismodal) return;
        let url = this.router.url;
        this.pageName = url.split('/')[1];
        this.pageName = this.pageName.split('?')[0];
        this.title = this.pageName;
        this.backButton = this.pageName != 'main';

        if (this.title.includes('main')) {
            let bis = this.businessService.getBusiness();
            this.title = bis.data.GlobalSettingsData.title;
        }

        // console.log(this.title);
        // console.log(this.pageName);

    }

    goTo(page, params = {}) {
        if (this.modal)
            this.close();

        this.tools.goTo(page);
    }

    // goBack() {
    //     if(this.modal)
    //         this.close();
    //
    //     if (this.backEvent) {
    //         this.events.publish(this.backEvent);
    //         return;
    //     }
    //
    //     this.navCtrl.pop();
    // }

    showMenu() {
        this.events.publish('showMenu');
    }

    async search() {
        if (this.modal) return;
        let me = this;
        const modal = await this.modalController.create({
            component: SearchPage,
            componentProps: {},
        });

        return await modal.present();
    }

    close() {
        this.modalController.dismiss({
            'dismissed': true
        });
    }

    goBack() {
        if (this.modal)
            this.close();

        this.tools.goBack();
    }
}
